import { render, staticRenderFns } from "./FrzProductionCategory.vue?vue&type=template&id=7da93a8a"
import script from "./FrzProductionCategory.vue?vue&type=script&lang=js"
export * from "./FrzProductionCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports